export default "__VITE_ASSET__BQ3Ki8lb__"